import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { LoadingController, Platform } from "ionic-angular";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";
import { GdEventReportDto } from "../../shared/nestjs/gd-only/dto/gd-event-report.dto";
import { GdEventReportApi } from "../../shared/nestjs/gd-only/services/gd-event-report.api";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";

@Injectable()
export class GdEventReportBloc {
  isGoPathNew: Boolean;
  loading: any;
  requestBody: GdEventReportDto = new GdEventReportDto();

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private loadingCtrl: LoadingController,
    private gdEventApi: GdEventReportApi,
    private analyticsProvider: AnalyticsProvider,
  ) {
  }

  getEventData(data: GdEventReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let getPeriod = this.gdEventApi.getEventData(data).subscribe(result => {
        resolve({ status: true, data: result })
      }, error => {
        reject({ status: true })
      }, () => {
        getPeriod.unsubscribe()
      })
    })
  }

  async downloadExcel(dataRequest: GdEventReportDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
      return await this.generateExcel(dataRequest)
    }

  }

  generateExcel(data: GdEventReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.gdEventApi.downloadExcel(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadExcelBlob(result, 'Timesheet Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Timesheet Report.xlsx')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      });
    });
  }


  async downloadPDF(dataRequest: GdEventReportDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
      return await this.generatePdf(dataRequest)
    }
  }

  private generatePdf(data: GdEventReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.gdEventApi.downloadPdf(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadPdfBlob(result, 'Event and Schedule Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Event and Schedule Report.pdf')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }

  async sendMailExcel(data: GdEventReportDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailExcel(data)
  }

  async sendMailPdf(data: GdEventReportDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailPdf(data)
  }

  private async sendEmailPdf(data: GdEventReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailPdf = this.gdEventApi.reportSendEmailPdf(data).subscribe(result => {
        resolve("Send Email Successfully")
      }, error => {
        reject(error.message);
        console.log('error', error);
      }, () => {
        sendEmailPdf.unsubscribe();
      })
    })
  }

  private async sendEmailExcel(data: GdEventReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailExcel = this.gdEventApi.reportSendEmailExcel(data).subscribe(result => {
        resolve("Send Email Successfully");
      }, error => {
        reject(error.message);
      }, () => {
        this.loading.dismiss();
        sendEmailExcel.unsubscribe();
      })
    })
  }


  loader(): void {
    this.loading = this.loadingCtrl.create();
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/gd-event-report.bloc.ts